export default {
    'currentTicket': {
        items: [],
        mode: 1,
        table_id: null
    },

    'currentClient': {
        full_name: '',
        phone: '',
        email: '',
        address: ''
    },

    'tickets': []
}